import QRModal from "./QRModal";
export default QRModal;
